/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './services/authentication/authentication.service';
import { PolytechUiService } from './shared/polytech-ui/shared/services/polytech-ui.service';
import { RouterOutlet } from '@angular/router';
import { SideMenuComponent } from './side-menu/side-menu.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SideMenuComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  title = 'Polytech-Spectrum-Frontend';
  constructor(
    private translate: TranslateService,
    private authService: AuthenticationService,
    private polytechUiService: PolytechUiService
  ) {
    this.translate.setFallbackLang('en');

    if (authService.hasValidAccessToken) {
      this.authService.decodeToken();
    }
  }
  ngOnInit(): void {
    this.polytechUiService.svgSprite = '/assets/images/polytech.svg';
  }
}
